import { Loader2 } from 'lucide-react';

import { cn } from '../../../lib';

export const Spinner = ({ className }: { className?: string }) => {
  return (
    <div className="flex justify-center items-center w-4 h-4">
      <Loader2 className={cn('animate-spin text-primary', className)} />
    </div>
  );
};
